var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Link',{attrs:{"href":`/#/managedSoftware/${_vm.softwareType}/${_vm.item.id}/details/Status`,"text":_vm.commandText}})
}
var staticRenderFns = []

export { render, staticRenderFns }